export default function() {
  const widgetName = 'cardWidgetQuickLinks';
  const widgetOpts = cardWidgetQuickLinksOpts;

  function appendToFooter(data) {
    const itemsLink = data.items;
    let footerList = '';
    itemsLink.map((item) => {
      let itemTitle = item.Title;
      let itemURL = item.Url;
      const footerItem = `
        <li class="topitem" aria-haspopup="false">
          <a href="${itemURL}" class="card-widget-footer-link">${itemTitle}</a>
        </li>
        <span class="separator">|</span>
      `;
      footerList += footerItem;
    });
    


    const footerNav = $('.bottom.footerItems1');
    footerNav.find('li').first().remove();
    footerNav.find('span').first().remove();
    footerNav.prepend(footerList);
    
  }
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data) {
      appendToFooter(data);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: false,
      margin: 10,
      navText: ['Prev','Next'],
      nav: false
    },
    textOverImage: false
  });

}